import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UndoIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Undo",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M29.94 20.29c-1.75-5.58-5.96-9.44-11.08-10.08s-10.26 2-13.35 6.5v-5.43c0-.97-.78-1.75-1.75-1.75s-1.75.78-1.75 1.75v9.39c0 .49.21.93.53 1.25.32.31.75.5 1.22.5h9.44c.97 0 1.75-.78 1.75-1.75s-.78-1.75-1.75-1.75H8.26c2.31-3.59 6.32-5.72 10.17-5.25 3.85.46 6.86 3.39 8.16 7.63.24.69.89 1.18 1.66 1.18a1.746 1.746 0 0 0 1.68-2.23s0 .04 0 .04Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M7.86 26.57c-.63 0-1.14-.51-1.14-1.14v-8c0-6.93 5.64-12.57 12.57-12.57s12.57 5.64 12.57 12.57v6.86a1.14 1.14 0 1 1-2.28 0v-6.86c0-5.67-4.61-10.29-10.29-10.29S9 11.75 9 17.43v8c0 .63-.51 1.14-1.14 1.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M7.86 26.57c-.29 0-.58-.11-.81-.33L.19 19.38a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l6.05 6.05 6.05-6.05a1.14 1.14 0 0 1 1.62 0c.45.45.45 1.17 0 1.62l-6.86 6.86c-.22.22-.52.33-.81.33"
      })]
    })
  }));
};
UndoIcon.displayName = 'UndoIcon';